var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 148,
    viewBox: "0 0 121 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5233 38.7271C28.5976 44.1313 17.6253 55.8965 13.6426 70.9963C19.6116 59.2115 29.9564 50.0079 42.5233 45.5386V38.7271Z",
    fill: "url(#paint0_linear_310_12563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7285 39.0636V45.8229C89.8995 50.3811 99.9016 59.4121 105.75 70.8979C101.825 56.1465 91.2237 44.5963 77.7285 39.0636Z",
    fill: "url(#paint1_linear_310_12563)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3107 12.4886C49.5488 12.4886 46.498 15.5384 46.498 19.3013V44.3513C50.725 43.229 55.1405 42.5695 59.7148 42.5687H59.7238C64.5915 42.5695 69.2873 43.2989 73.7563 44.5647L73.7833 19.2666C73.7871 16.1191 75.8537 13.7258 80.5599 12.4901L53.3107 12.4886Z",
    fill: "#827677"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 51.3359,
    y1: 18.5195,
    x2: 69.6693,
    y2: 18.5195,
    stroke: "#EDECF7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3359,
    y1: 21.8529,
    x2: 69.6693,
    y2: 21.8529,
    stroke: "#EDECF7"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3359,
    y1: 25.1862,
    x2: 69.6693,
    y2: 25.1862,
    stroke: "#EDECF7"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3359,
    y1: 28.5195,
    x2: 69.6693,
    y2: 28.5195,
    stroke: "#EDECF7"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3359,
    y1: 31.8529,
    x2: 69.6693,
    y2: 31.8529,
    stroke: "#EDECF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.756 142.984C44.3591 133.609 53.52 116.877 57.9776 96.8013C58.1579 96.0145 58.8461 95.4575 59.6655 95.4575C60.4848 95.4575 61.1731 96.0145 61.3533 96.8013C65.8111 116.844 74.9559 133.593 86.5749 142.984C101.046 133.249 109.666 116.697 109.666 98.4893C109.666 69.3673 87.2468 45.6862 59.6817 45.6862C32.1166 45.6862 9.66602 69.3673 9.66602 98.4893C9.66602 116.713 18.2699 133.249 32.7571 142.984H32.756Z",
    fill: "url(#paint2_linear_310_12563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_12563",
    x1: 11.7653,
    y1: 80.6771,
    x2: 52.6499,
    y2: 67.9501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_12563",
    x1: 75.9071,
    y1: 80.4482,
    x2: 115.69,
    y2: 68.2688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_12563",
    x1: 3.16602,
    y1: 172.173,
    x2: 140.852,
    y2: 122.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedCookie);
export default __webpack_public_path__ + "static/media/opened-cookie.00dc37f63676869693df83300fba775d.svg";
export { ForwardRef as ReactComponent };